import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { ElMessage } from "element-plus";
import store from "@/store/index"
import router from "@/router/index"
import service from "./service";
let message = "";
service.interceptors.request.use(
  (config: any) => {
    //给请求头设置token
    const token = sessionStorage.getItem("token");
    const noToken = config.noToken || false;
    console.log(config)
    if (token && !noToken) {
      config.headers!.Authorization = `Bearer `+ token;
    }
    message = "";
    return config;
  },
  (error: AxiosError) => {
    ElMessage.error(error.message);
    return Promise.reject(error);
  }
);

/* 响应拦截器 */
service.interceptors.response.use(
  (response: AxiosResponse) => {
    console.log(response)
    if(response.status==200 && response.config.responseType=="blob"){
      return Promise.resolve(response.data);
    }
    const { code, msg, data } = response.data; // 根据自定义错误码判断请求是否成功
    if (code === 200) {
      // 将组件用的数据返回
      return Promise.resolve(response.data);
    } else {
      // 处理业务错误。
      ElMessage.error(msg);
      return Promise.reject(response);
    }
  },
  (error: AxiosError) => {
    console.log(error)
    // 处理 HTTP 网络错误
    if(message) return
    // HTTP 状态码
    const status = error.status;
    switch (status) {
      case 401:
        // message = "登录体验更多功能";
        store.dispatch('setGradeTerm', {
            grade:'三年级',
            term:'上学期'
        })
        if(!['/composition/teaching','/composition/pastExamPaper'].includes(store.state.nowRouter)){
          store.dispatch('setLoginFlag')
        }
        break;
      case 403:
        message = "没有权限,请获取权限后登录";
        break;
      case 404:
        message = "接口请求失败";
        router.push({path:'/composition/teaching'})
        break;
      case 500:
        message = "服务器故障";
        break;
      case 502:
        message = "数据库查询错误";
        break;
      default:
        message = "网络连接错误";
    }
    message && ElMessage.error(message);
    return Promise.reject(error);
  }
);

export default service